import {
  getFilteredDataset,
  getVisibleNumericalSelectedParametersNames,
  getVisibleCategoricalSelectedParametersNames
} from 'store/dataset';

import { getCategoricalSummary, getNumericalSummary } from 'calculators/dataset/rawTable';

import { SET_SUMMARY } from './types';

export const setSummary = summary => ({
  type: SET_SUMMARY, summary
});


export const calculateRawDatasetSummary = () => (dispatch, getState) => {
  const state = getState();

  const dataset = getFilteredDataset()(state);
  const numericalSummary = getNumericalSummary(
    dataset, getVisibleNumericalSelectedParametersNames(state)
  );

  const categoricalSummary = getCategoricalSummary(
    dataset, getVisibleCategoricalSelectedParametersNames(state)
  );

  dispatch(setSummary({
    categoricalSummary,
    numericalSummary
  }));
};

